module.exports = __webpack_public_path__ + "static/media/blog5_sm.560836d0.webp";